import { useState } from 'react'
import './PromptPreview.css'

function PromptPreview({ prompt, frameCount }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [copied, setCopied] = useState(false)

  if (!prompt) {
    return null
  }

  const handleCopy = async (e) => {
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(prompt)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  // Calculate approximate token count (rough estimate: ~4 chars per token)
  const estimatedTokens = Math.ceil(prompt.length / 4)

  return (
    <div className="prompt-preview">
      <div 
        className="prompt-preview-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3>
          <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>▶</span>
          LLM Prompt Preview
        </h3>
        <div className="prompt-preview-meta">
          <span className="meta-item">~{estimatedTokens.toLocaleString()} tokens (text)</span>
          <span className="meta-item">{frameCount} images</span>
        </div>
      </div>
      
      {isExpanded && (
        <div className="prompt-preview-content">
          <div className="prompt-preview-toolbar">
            <button 
              className="prompt-copy-btn"
              onClick={handleCopy}
            >
              {copied ? '✓ Copied!' : '📋 Copy Prompt'}
            </button>
          </div>
          <pre className="prompt-text">{prompt}</pre>
        </div>
      )}
    </div>
  )
}

export default PromptPreview

